import tagTester from './_tagTester.js';

export default tagTester('String');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/isString.js
// module id = 246
// module chunks = 106